import React, { useState } from "react";
import { Form, Container } from "react-bootstrap";
import "./Activity_Bonus.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { faCamera, faUpload, faCloudUploadAlt, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SubmitActivityBonus } from "../../features/support/slice";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";

const uploadFields = [
  { id: "winning_record_screenshot_1", label: "Screenshot of winning record 1", mandatory: true, accept: "image/*" },
  { id: "winning_record_screenshot_2", label: "Screenshot of winning record 2", mandatory: false, accept: "image/*" },
  { id: "attach_video", label: "Attach Video", mandatory: false, isFile: true, accept: "video/*" },
];

const requiredFileIds = ["winning_record_screenshot_1"];

function Activity_Bonus() {

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [files, setFiles] = useState({
    winning_record_screenshot_1: null,
    winning_record_screenshot_2: null,
    attach_video: null,
  });

  const [previews, setPreviews] = useState({
    winning_record_screenshot_1: null,
    winning_record_screenshot_2: null,
    attach_video: null,
  });

  const [fileErrors, setFileErrors] = useState({});

  const [bonusTextLength, setBonusTextLength] = useState(0);

  const handleFileChange = (e, key) => {

    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));

    setFileErrors((prev) => ({
      ...prev,
      [key]: null,
    }));

    e.target.value = "";

  };

  const validateFiles = () => {

    const newErrors = {};

    requiredFileIds.forEach((id) => {
      if (!files[id]) {
        const field = uploadFields.find((f) => f.id === id);
        newErrors[id] = `${field?.label} is required`;
      }
    });

    setFileErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (data) => {

    if (!validateFiles()) return;

    const formData = new FormData();

    formData.append("bonus_description", data.bonus_text.trim());
    formData.append("user_uid", data.user_uid.trim());

    Object.entries(files).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    const res = await dispatch(SubmitActivityBonus(formData));

    if (res.meta?.requestStatus === "fulfilled") {
      setModalMessage(res?.payload?.data || "Bank Information Modified Successfully");
      setModalShow(true);
      reset();
      setFiles(Object.fromEntries(Object.keys(files).map((k) => [k, null])));
      setPreviews(Object.fromEntries(Object.keys(previews).map((k) => [k, null])));
      setFileErrors({});
      setBonusTextLength(0);
      setTimeout(() => {
        setModalShow(false);
        navigate(-1);
      }, 2000);
    } else {
      setModalShow(true);
      setModalMessage(
        res?.payload?.errors || "Submission failed. Please try again"
      );
      setTimeout(() => setModalShow(false), 3000);
    }

  };

  return (
    <>
      <section className="Activity_Bonus_Section Modify_Bank_Information">

        <Common_white_header headingText={"Activity Bonus"} />

        <Container>

          <Form className="mt-3" onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Bonus Description */}

            <Form.Group className="form-group field_holder">

              <Form.Label>
                Explain clearly bonus that want be claimed
                <span className="mandatory_estrics">*</span>
              </Form.Label>

              <div className="textarea_container">

                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Please enter content"
                  maxLength={500}
                  {...register("bonus_text", {
                    required: "Bonus description is required",
                    maxLength: {
                      value: 500,
                      message: "Maximum 500 characters allowed",
                    },
                  })}
                  onChange={(e) => setBonusTextLength(e.target.value.length)}
                />

                <div className="char_counter">
                  {bonusTextLength}/500
                </div>

              </div>

              {errors.bonus_text && (
                <small className="text-danger">
                  {errors.bonus_text.message}
                </small>
              )}

            </Form.Group>


            {/* Money King ID */}

            <Form.Group className="form-group field_holder">

              <Form.Label>
                Money King ID
                <span className="mandatory_estrics">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Please enter User ID"
                onInput={(e) =>
                  (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                }
                {...register("user_uid", {
                  required: "Money King ID is required",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Only numbers allowed",
                  },
                })}
              />

              {errors.user_uid && (
                <small className="text-danger">
                  {errors.user_uid.message}
                </small>
              )}

            </Form.Group>


            {/* Upload Fields */}

            {uploadFields.map((item) => (

              <Form.Group className="form-group field_holder" key={item.id}>

                <Form.Label>
                  {item.label}
                  {item.mandatory && (
                    <span className="mandatory_estrics">*</span>
                  )}
                </Form.Label>

                <div className="upload_box">

                  <input
                    type="file"
                    id={item.id}
                    hidden
                    accept={item.accept}
                    onChange={(e) => handleFileChange(e, item.id)}
                  />

                  <label htmlFor={item.id} className="photo_label">
                    {previews[item.id] && (
                      <div className="close-btn">
                        <FontAwesomeIcon
                          icon={faXmark}
                          onClick={(e) => {
                            // e.stopPropagation();
                            e.preventDefault();  // extra safety
                            setPreviews((prev) => ({
                              ...prev,
                              [item.id]: null,
                            }));
                          }}
                        />
                      </div>
                    )}
                    {previews[item.id] &&
                      previews[item.id] !== "file_uploaded" ? (

                      <img
                        src={previews[item.id]}
                        alt="Preview"
                        className="uploaded_img_preview"
                      />

                    ) : previews[item.id] === "file_uploaded" ? (

                      <div className="success_upload">
                        <FontAwesomeIcon
                          icon={faCloudUploadAlt}
                          style={{ color: "#28a745" }}
                        />
                        <span>Uploaded</span>
                      </div>

                    ) : (

                      <>
                        <FontAwesomeIcon
                          icon={item.isFile ? faUpload : faCamera}
                        />
                        <span>
                          {item.isFile ? "Upload" : "photo"}
                        </span>
                      </>

                    )}

                  </label>

                </div>

                {fileErrors[item.id] && (
                  <small className="text-danger">
                    {fileErrors[item.id]}
                  </small>
                )}

              </Form.Group>

            ))}


            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>

        </Container>
        <Successfull_strip_modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          textMsg={modalMessage}
        />
      </section>
    </>
  );
}

export default Activity_Bonus;